import {isNil} from "../Helper";

export default function initUploadFields() {

  const uploadFields = document.querySelectorAll('.clear-file-input');

  uploadFields.forEach((item) => {
    //console.log(item);
    item.addEventListener('click', function () {
      const fieldName = item.getAttribute('data-field-name');
      item.parentNode.classList.toggle('hidden');

      const fileInput = document.getElementById(fieldName);
      fileInput.classList.toggle('is-invalid');
      fileInput.classList.toggle('has-file');
      fileInput.value = ''

      const hiddenInput = document.getElementsByName(fieldName + '[originallySubmittedResource][__identity]');
      hiddenInput.value = ''

      const errorMessage = document.getElementById(fieldName + '-errors');
      errorMessage.classList.toggle('filled');


    });
  });
}
